import styled from 'styled-components';
import {basicRow} from '../../../../../../component/newTable/newRow/Row.css';
import {scrollbar} from '../../../../../../globalVariables/GlobalVariables';
import {justifyAround} from '../../../../../../globalVariables/GlobalFlex';
import {header} from '../../../../../../component/newTable/header/Header.css';

export const container = styled.div`
    ${scrollbar}
    ${basicRow}{
        ${justifyAround}
        height: 'max-content';
    }
    ${header}{
        height: 40px;
    }
 `;
